// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","Primary":"Button_Primary__KQ6pW","Secondary":"Button_Secondary__CZgmr"};